<template>
  <div class="preview-container">
    <el-scrollbar style="width: 100%; height: 100%">
      <el-tabs v-if="formConfig.formKey" type="card" @tab-click="handleClick">
        <el-tab-pane label="Mobile">
          <span slot="label">
            <i class="el-icon-mobile" />
            手机
          </span>
          <div
            :style="{
              width: previewQrcode ? '800px' : '400px',
              position: previewQrcode ? 'relative' : ''
            }"
          >
            <div style="margin-top: 20px" :class="{ 'preview-phone': curTab == 'Mobile' }">
              <div :class="{ 'preview-html': curTab == 'Mobile' }">
                <biz-project-form
                  ref="projectFormRefMobile"
                  v-if="formConfig.formKey"
                  :form-config="formConfig"
                  :requestUrl="detailUrl"
                />
              </div>
            </div>
            <!-- <div class="preview-layer">
          <div class="preview-bg" />
          <div class="preview-phone">
            <iframe
              id="preview-html"
              :src="mobilePreviewUrl"
              class="preview-html"
              frameborder="0"
              name="preview-html"
              scrolling="auto"
            />
          </div>
        </div> -->
            <div v-if="mobilePreviewUrl && previewQrcode" class="qrcode-view">
              <p style="font-weight: bold; font-size: 16px">手机扫码预览</p>
              <p class="tips-text">* 当前为预览页，答案不被记录</p>
              <p>
                <vue-qr
                  v-if="mobilePreviewUrl && previewQrcode"
                  :size="134"
                  style="border-radius: 10px"
                  :text="mobilePreviewUrl"
                />
              </p>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="Pc">
          <span slot="label"><i class="el-icon-monitor" /> 电脑 </span>
          <!-- <el-scrollbar style="height: 80vh; overflow-x: hidden !important">
          <biz-project-form v-if="formConfig.formKey" :form-config="formConfig" /> -->
          <!-- <FormDesign :question-mode="true" /> -->
          <!-- </el-scrollbar> -->
          <div style="margin-top: 20px" class="preview-pc">
            <biz-project-form
              ref="projectFormRefPc"
              v-if="formConfig.formKey && curTab == 'Pc'"
              :form-config="formConfig"
              :requestUrl="detailUrl"
            />
          </div>
        </el-tab-pane>
      </el-tabs>
    </el-scrollbar>
  </div>
</template>

<script>
import BizProjectForm from '@/components/FormGen/BizProjectForm/index'
import FormDesign from '@/components/FormGen/FormDesign'
import ProjectForm from './ProjectForm.vue'
// import 'tduck-form-generator/dist/TduckForm.css'
import VueQr from 'vue-qr'
import mixin from '../TduckFormMixin'

export default {
  name: 'PreView',
  components: {
    BizProjectForm,
    VueQr,
    FormDesign,
    ProjectForm
  },
  mixins: [mixin],
  props: {
    previewQrcode: {
      type: Boolean,
      default: false
    }, // 是否预览
    formPropKey: {
      type: String,
      default: ''
    },
    detailUrl: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      formKey: null,
      mobilePreviewUrl: '',
      projectFormKey: +new Date(),
      formConfig: {
        formKey: '',
        showBtns: true,
        showItem: 'start',
        isPcOrMobile: 'Mobile'
      },
      curTab: 'Mobile'
    }
  },
  watch: {
    formPropKey(val) {
      if (val) {
        this.setFormKey(val)
      }
    }
  },
  provide() {
    return {
      formWriteSubmit: (params) => this.submitForm(params),
      formConfig: this.formConfig
    }
  },
  mounted() {
    this.setFormKey(this.$route.query.key)
  },
  methods: {
    setFormKey(key) {
      this.formKey = key || this.formPropKey
      let url = window.location.protocol + '//' + window.location.host
      this.mobilePreviewUrl = `${url}/project/form/view?key=${this.formKey}`
      this.$set(this.formConfig, 'formKey', this.formKey)
    },
    handleClick(tab) {
      this.curTab = tab.label
      this.formConfig.isPcOrMobile = tab.label
      // this.$refs[`projectFormRef${tab.label}`].formConf.isPcOrMobile = tab.label
    },
    changeFormConfig() {
      if (this.$refs.projectFormRefMobile) {
        this.$refs.projectFormRefMobile.changeFormConfig()
      }
      if (this.$refs.projectFormRefPc) {
        this.$refs.projectFormRefPc.changeFormConfig()
      }
    },
    submitForm() {
      this.formConfig.showItem = 'end'
    }
  }
}
</script>

<style lang="scss" scoped>
.tips-text {
  margin-top: 10px;
  margin-bottom: 10px;
}
.preview-container {
  min-width: 400px;
  width: 100%;
  height: 100%;
  margin: 0;
  // padding: 30px 0;
  // height: 100vh;
  overflow: hidden !important;
  background-color: var(--color-bg);
}

::v-deep .el-tabs--card > .el-tabs__header .el-tabs__nav {
  border: 1px solid #e4e7ed !important;
  border-radius: 10px;
  background-color: white;
}

::v-deep .el-dialog__body {
  max-height: calc(100vh - 200px) !important;
}

::v-deep .el-tabs--card > .el-tabs__header .el-tabs__item {
  background-color: transparent;
  //border: 1px solid white;
}

.project-form-package {
  background-color: transparent;
}

div.preview-layer {
  width: 500px;
  height: 100%;
  margin: 10px auto;
  right: 0;
  text-align: center;
}

div.preview-layer .preview-bg {
  width: 500px;
  height: 100%;
  margin: 20px auto;
  z-index: 999;
  opacity: 0.7;
}

.el-tabs {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin: 30px 0;
  ::v-deep .el-tabs__header {
    margin: 0;
  }
}
</style>
<style lang="scss">
.preview-phone {
  width: 382px;
  height: 784px;
  padding: 77px 16px;
  background: url('~@/assets/images/appearset_bgc_big.png');
  background-size: 100% 100%;
  z-index: 1000;
  margin: 0 auto;
}

.qrcode-view {
  position: absolute;
  top: 20px;
  right: 0;

  p {
    text-align: center;
    font-size: 12px;
    color: #303133;
  }
}

.preview-html {
  width: 350px !important;
  height: 602px !important;
  border-radius: 5px;
  outline: none;
  // background-color: #fff;
  border-width: 2px;
  border-style: inset;
  border-color: initial;
  border-image: initial;
  border-top-width: 0;
  border-right-width: 0;
  border-bottom-width: 0;
  border-left-width: 0;
  .project-form-package {
    width: 100%;
    height: 100%;
    .define-theme-form-start {
      height: 200px;
    }
  }
}
.preview-pc {
  .project-form-package {
    height: 83vh;
  }
}
</style>
